<template>
    <div>
        <!-- Tiêu đề -->
        <div class="flex-tt">
            <h2 class="td-tt">{{ $t("manage_lesson.static") }}</h2>
        </div>

        <div v-if="results.length == 0 && !first">
            <div class="nameTestExam">
                <span>{{ $t("scoreStaticNew.noInformation") }}</span>
            </div>
        </div>

        <!-- Danh sách lịch sử thi cuối kì -->
        <template v-for="(item, index) in results">
            <div :key="index">
                <!-- Tên kì thi -->
                <div class="nameTestExam">
                    <span>{{ $t("scoreStatistics.testName") }}: </span>
                    <span>{{item.examId == null ? $t("scoreStatistics.finalExam") : item.examName }}</span>
                </div>

                <div class="nameTestExam">
                    <button class="btn-download-tt" @click="downLoadAll(item)">{{ $t("scoreNew.title9") }}</button>
                    <button class="btn-download-tt" @click="getWrongBookUser(item)">{{ $t("new.title193") }}</button>
                </div>

                <!-- Danh sách -->
                <div class="exam_begins_box">
                    <div class="course_box">
                        <div class="exam_begins_rule_content">
                            <el-table :data="item.list">
                                <!-- Stt -->
                                <el-table-column type="index" :label="$t('courseList.no')" header-align="center" align="center" width="60">
                                    <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                                </el-table-column>

                                <!-- Thời gian làm bài thi -->
                                <el-table-column prop="timeExamStart" :label="$t('scoreStaticNew.timeExamStart')" header-align="center" align="center" min-width="100px" width="180"></el-table-column>

                                <!-- Thời gian kết thúc làm bài thi -->
                                <el-table-column prop="timeExamEnd" :label="$t('scoreStaticNew.timeExamEnd')" header-align="center" align="center" min-width="100px" width="180"></el-table-column>

                                <!-- Số phút làm bài thi -->
                                <el-table-column prop="timeExamConduct" :label="$t('scoreStaticNew.timeExamConductedNew')" header-align="center" align="center" min-width="100px" width="180">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.timeExamConduct }}</span>
                                        <span>{{$t('manage_student.minute')}}</span>
                                    </template>
                                </el-table-column>

                                <!-- Điểm tối đa -->
                                <el-table-column prop="fullMarks" :label="$t('new.title24')" header-align="center" align="center" min-width="100px" width="140">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.score == null">-</span>
                                        <span v-if="scope.row.score != null">{{ scope.row.fullMarks }}</span>
                                    </template>
                                </el-table-column>

                                <!-- Điểm đậu -->
                                <el-table-column prop="res" :label="$t('scoreStatistics.passPercent')" header-align="center" align="center" min-width="100px" width="140">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.score == null">-</span>
                                        <span v-if="scope.row.score != null">{{ scope.row.checkPassMark }}</span>
                                    </template>
                                </el-table-column>

                                <!-- Điểm đạt được -->
                                <el-table-column prop="score" :label="$t('examResume.point')" header-align="center" align="center" min-width="100px" width="140">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.score == null">-</span>
                                        <span>{{ scope.row.score }}</span>
                                    </template>
                                </el-table-column>

                                <!-- Trạng thái -->
                                <el-table-column prop="examType" :label="$t('scoreStatistics.judge')" header-align="center" align="center" min-width="90px" width="150">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.score == null">-</span>
                                        <span v-if="scope.row.score != null && Number(scope.row.score) >= Number(scope.row.passPercentScore)">
                                            {{ $t("scoreStatistics.point90") }}
                                        </span>
                                        <span v-if="scope.row.score != null && Number(scope.row.score) < Number(scope.row.passPercentScore)">
                                            {{ $t("scoreStatistics.point80") }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="score" :label="$t('scoreNew.title10')" header-align="center" align="center" min-width="100px" width="140">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small">
                                            <a class="btn_show_details_exam" @click="showDetailsExam(scope.row)" target="_blank">{{$t('courseProgress.look')}}</a>
                                        </el-button>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="score" :label="$t('new.title79')" header-align="center" align="center" min-width="100px" width="140">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small">
                                            <a class="btn_show_details_exam" @click="downLoadFile(scope.row)" target="_blank">{{$t('manage.download')}}</a>
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <!-- The Modal -->
        <div v-if="showDialog" id="myModal" class="modal">
            <!-- Modal content -->
            <div class="modal-content">
                <div class="modal_header">
                    <span class="modal_header_name_exam">
                        <template v-if="dataDetailsClick.examName=='-'">
                            {{ $t("scoreStatistics.finalExam") }}
                        </template>
                        <template v-else>
                            {{dataDetailsClick.examName}}
                        </template>
                    </span>
                    <span class="closeModal" v-on:click="closeModal()">
                        <div class="img_exit_login">
                            <img src="../../../../static/images/wrong-while_hover.png" />
                        </div>
                    </span>
                </div>
                <!-- Display detail exam -->
                <div class="modal_body">
                    <div class="modal_body_exam">
                        <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("new.title24") }}: </span>{{dataDetailsClick.fullMarks}} {{ $t("scoreStatistics.message2") }}</span>
                        <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("scoreStatistics.passPercent") }}: </span>{{dataDetailsClick.checkPassMark}} {{ $t("scoreStatistics.message2") }}</span>
                    </div>
                    <div class="modal_body_exam">
                        <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("examResume.point") }}: </span>{{dataDetailsClick.score}} {{ $t("scoreStatistics.message2") }}</span>
                        <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("scoreStatistics.result") }}: </span>
                            <template v-if="dataDetailsClick.score != null &&Number(dataDetailsClick.score) >= Number(dataDetailsClick.checkPassMark)">{{ $t("scoreStatistics.point90") }}</template>
                            <template v-if="dataDetailsClick.score != null &&Number(dataDetailsClick.score) < Number(dataDetailsClick.checkPassMark)">{{ $t("scoreStatistics.point80") }}</template>
                        </span>
                    </div>
                    <div class="modal_body_exam">
                        <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("examResume.time") }}: </span>{{dataDetailsClick.examDate}}</span>
                        <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("scoreStaticNew.timeExamConductedNew") }}: </span>{{dataDetailsClick.timeExamConduct}} {{ $t("manage_student.minute") }}</span>
                    </div>
                    <div class="modal_body_currilumn">
                        <span class="modal_body_currilumn_header">{{ $t("scoreNew.title1") }}</span>
                        <div class="modal_body_currilumn_header_hd">
                            <span class="modal_body_currilumn_header_hd_ct tnv_ct"></span>
                        </div>
                    </div>
                </div>
                <chartDetailExam :data="{
                    recordId  : this.recordId,
                    studentId : this.data.studentId,
                    courseId  : this.data.courseId,
                    examId    : this.examId
                }"/>
            </div>
        </div>
        <loading class="loading--lesson" :showLoading="!isLoadData" />
    </div>
</template>

<script>
import loading from "@/components/loading/loading";
import { mapState, mapMutations } from "vuex";
import chartDetailExam from "@/components/exam/chartDetailExam";

export default {
    props: {
        data: {
            type: Object,
            default: {},
        },
    },
    components: {
        loading,
        chartDetailExam
    },
    data() {
        return {
            results: [],
            first: true,
            isLoadData: true,
            showDialog: false,
            dataDetailsClick: null,
            listDataDetailsShowDialog: [],
            obWrongExam: {},
            recordId: null,
            examId: null
        };
    },
    created() {
        this.init({ courseId: this.data.courseId, studentId: this.data.studentId });
    },
    computed: {
        // Lấy dữ liệu từ store
        ...mapState({
            mobile: (state) => state.header.mobile,
        }),
    },
    methods: {
        init: async function (param) {
            const self = this;

            // Lấy số kì thi của khóa học
            let result = await this.getsingleCourseScoreStatistics(param);
            var listScoreStatic = [];
            result.forEach((value) => {
                if (value.examId != null && value.examName == null) {
                    return;
                } else {
                    listScoreStatic.push(value);
                }
            });
            Promise.all(
                listScoreStatic.map((item) => {
                    return self.getExamRecord(item);
                })
            ).then(function (results) {
                self.results = results;
                self.first = false;
            });
        },

        // Lấy tiến độ của khóa học
        getExamRecord: function (data) {
            return new Promise((resolve, reject) => {
                this.$api
                    .post("/home/getExamRecord", {
                        userId: data.studentId,
                        courseId: data.courseId,
                        examId: data.examId,
                        languageType: this.$lang(),
                    })
                    .then((response) => {
                        const courses = response.data.list.reduce((accumulator, value) => {
                            value["courseId"]         = data.courseId;
                            value["studentId"]        = data.studentId;
                            value["examId"]           = data.examId;
                            value["passPercentScore"] = (parseInt(value.fullMarks) / 100) * data.passPercent;
                            value["checkPassMark"]    = (parseInt(value.fullMarks) / 100) * data.passPercent;
                            value["fullMarksScore"]   = parseInt(value.fullMarks);
                            accumulator.push(value);
                            return accumulator;
                        }, []);
                        data["list"] = courses;
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err.response);
                    });
            });
        },

        // Lấy số kì thi trong khóa học
        getsingleCourseScoreStatistics: function (data) {
            return new Promise((resolve, reject) => {
                this.$api
                    .post("/home/getsingleCourseScoreStatistics", {
                        userId: data.studentId,
                        courseId: data.courseId,
                        languageType: this.$lang(),
                    })
                    .then((response) => {
                        const courses = response.data.reduce((accumulator, value) => {
                            let obj = {
                                courseId: data.courseId,
                                studentId: data.studentId,
                                examId: value.examId,
                                passPercent: value.passPercent,
                                examName: value.examName,
                            };
                            obj.courseId = value.examId != null ? null : obj.courseId;
                            accumulator.push(obj);
                            return accumulator;
                        }, []);
                        resolve(courses);
                    })
                    .catch((err) => {
                        reject(err.response);
                    });
            });
        },

        // vuex
        ...mapMutations("manageDetail", []),
        /// Hiển thị dialog chi tiết thi từng phần
        showDetailsExam(params) {
            this.isLoadData       = false;
            this.dataDetailsClick = params;
            this.examId           = params.examId || null;
            this.recordId         = params.id;
            this.isLoadData       = true;
            this.showDialog       = true;
        },
        /// Đóng dialog
        closeModal() {
            this.showDialog = false;
        },
        /// downLoad từng phần trong mục thi
        downLoadFile(params) {
            let tempList = [];
            let dataClick = params;
            this.isLoadData = false;
            let courseIdHistoryDataScoreStatic = this.data.courseId;
            let examIdHistoryDataScoreStatic = null;
            if (params.examId) {
                examIdHistoryDataScoreStatic = params.examId;
            }
            let temp = [];
            this.$api
                .post("/courseStudy/getScoreRate", {
                    id: params.id,
                    studentId: this.data.studentId,
                    courseId: courseIdHistoryDataScoreStatic,
                    examId: examIdHistoryDataScoreStatic,
                })
                .then((response) => {
                    this.isLoadData = true;
                    response.data.forEach((value) => {
                        value["timeBegin"] = dataClick.timeExamStart;
                        value["timeEnd"] = dataClick.timeExamEnd;
                        if (value.totalAnswer != null) {
                            value["wrongAnswer"] = parseInt(value.totalAnswer) - parseInt(value.rightAnswer);
                        } else {
                            value["wrongAnswer"] = "-";
                            value.totalAnswer = "-";
                            value.rightAnswer = "-";
                            value.score = "-";
                        }
                        temp.push(value);
                    });

                    temp.forEach((el) => {
                        if (el.score !== "-") {
                            tempList.push(el);
                        }
                    });

                    var headerName = [
                        {
                            key: "timeBegin",
                            value: "scoreStaticNew.timeExamStart",
                        },
                        {
                            key: "timeEnd",
                            value: "scoreStaticNew.timeExamEnd",
                        },
                        {
                            key: "chapterName",
                            value: "scoreNew.title4",
                        },
                        {
                            key: "totalAnswer",
                            value: "scoreNew.title5",
                        },
                        {
                            key: "rightAnswer",
                            value: "scoreNew.title6",
                        },
                        {
                            key: "wrongAnswer",
                            value: "scoreNew.title7",
                        },
                        {
                            key: "score",
                            value: "scoreNew.title8",
                        },
                    ];
                    var params = {
                        header: true,
                        titles: ["timeBegin", "timeEnd", "chapterName", "totalAnswer", "rightAnswer", "wrongAnswer", "score"],
                        data: tempList,
                        headerName: headerName,
                        name: "exportDetailExam.csv",
                    };
                    this.exportCsv(params);
                });
        },
        /// downLoad tất cả trong bài thi đó
        downLoadAll(params) {
            const self = this;
            if (params.list) {
                this.isLoadData = false;
                Promise.all(
                    params.list.map((item) => {
                        return self.getDataScoreExam(params, item);
                    })
                ).then(function (results) {
                    let tempList = [];
                    let temp = [];
                    results.forEach((item) => {
                        item.listDataScore.forEach((value) => {
                            temp.push(value);
                        });
                    });
                    temp.forEach((el) => {
                        if (el.score !== "-") {
                            tempList.push(el);
                        }
                    });
                    self.isLoadData = true;
                    var headerName = [
                        {
                            key: "timeBegin",
                            value: "scoreStaticNew.timeExamStart",
                        },
                        {
                            key: "timeEnd",
                            value: "scoreStaticNew.timeExamEnd",
                        },
                        {
                            key: "chapterName",
                            value: "scoreNew.title4",
                        },
                        {
                            key: "totalAnswer",
                            value: "scoreNew.title5",
                        },
                        {
                            key: "rightAnswer",
                            value: "scoreNew.title6",
                        },
                        {
                            key: "wrongAnswer",
                            value: "scoreNew.title7",
                        },
                        {
                            key: "score",
                            value: "scoreNew.title8",
                        },
                    ];
                    var paramsrs = {
                        header: true,
                        titles: ["timeBegin", "timeEnd", "chapterName", "totalAnswer", "rightAnswer", "wrongAnswer", "score"],
                        data: tempList,
                        headerName: headerName,
                        name: "exportDetailExam.csv",
                    };
                    self.exportCsv(paramsrs);
                });
            }
        },
        /// get thông tin thi từng phần thi
        getDataScoreExam(params, item) {
            const self = this;
            return new Promise((resolve, reject) => {
                let dataClick = item;
                let courseIdHistoryDataScoreStatic = this.data.courseId;
                let examIdHistoryDataScoreStatic = null;
                if (item.examId) {
                    examIdHistoryDataScoreStatic = item.examId;
                }
                this.$api
                    .post("/courseStudy/getScoreRate", {
                        id: item.id,
                        studentId: this.data.studentId,
                        courseId: courseIdHistoryDataScoreStatic,
                        examId: examIdHistoryDataScoreStatic,
                    })
                    .then((response) => {
                        response.data.forEach((value) => {
                            value["timeBegin"] = dataClick.timeExamStart;
                            value["timeEnd"] = dataClick.timeExamEnd;
                            if (value.totalAnswer != null) {
                                value["wrongAnswer"] = parseInt(value.totalAnswer) - parseInt(value.rightAnswer);
                            } else {
                                value["wrongAnswer"] = "-";
                                value.totalAnswer = "-";
                                value.rightAnswer = "-";
                                value.score = "-";
                            }
                        });
                        item["listDataScore"] = response.data;
                        resolve(item);
                    })
                    .catch((err) => {
                        reject(err.response);
                    });
            });
        },
        /// Lấy danh sách câu trả lời sai
        getWrongBookUser(params) {
            this.isLoadData = false;
            this.$api
                .post("/studyCourseQuestion/getWrongBook", {
                    languageType: this.$lang(),
                    courseId: this.data.courseId,
                    examId: params.examId,
                    userId: this.data.studentId,
                })
                .then((response) => {
                    this.isLoadData = true;
                    if (response.data.length == 0) {
                        this.$confirm(window.vm.$i18n.t("new.title113"), window.vm.$i18n.t("new.title194"), { cancelButtonClass: "btn-nqt---show" })
                            .then(() => {})
                            .catch(() => {});
                    } else {
                        let dataWrongExam = {};
                        dataWrongExam.list = response.data;
                        dataWrongExam.showTypeWrongExam = true;
                        this.$emit("clickShowWrongExam", dataWrongExam);
                    }
                });
        },
    },
};
</script>

<style scoped>
    .nqtLearnPercent {
        margin-bottom: 15px;
    }
    .exam_begins_box {
        margin-top: 10px !important;
    }
    .nameTestExam {
        padding-left: 5px;
    }
    /* Hiển thị modal */
    .btn_show_details_exam {
        background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
        padding: 3px 8px;
        border-radius: 15px;
        -webkit-transition: 0.5s ease;
        transition: 0.5s ease;
        color: #fff;
    }
    .modal {
        position: fixed; /* Stay in place */
        z-index: 1001; /* Sit on top */
        padding-top: 100px; /* Location of the box */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0, 0, 0); /* Fallback color */
        background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
    }
    /* Modal Content */
    .modal-content {
        background-color: #fefefe;
        /* background-image: linear-gradient(0deg, #d5f1ff 0%, #53e0fd 100%); */
        margin: auto;
        padding: 0px 10px;
        border: 1px solid #888;
        width: 50%;
        border-radius: 10px;
        min-height: 100px;
    }
    .img_exit_login {
        float: right;
        margin-right: 0px;
        margin-top: 0px;
        padding: 0px;
        cursor: pointer;
    }
    .modal_header_name_exam {
        font-weight: bold;
        font-size: 18px;
    }
    .modal_header {
        padding-top: 5px;
    }
    .modal_body {
        padding-top: 20px;
    }
    .modal_body_exam {
        display: flex;
    }
    .modal_body_exam .modal_body_exam_title {
        font-size: 13px;
        width: 50%;
        padding-top: 1vh;
    }
    .modal_body_exam_title_tl {
        font-weight: bold;
    }
    .modal_body_currilumn {
        padding-top: 2vh;
        padding-bottom: 2vh;
    }
    .modal_body_currilumn_header {
        font-size: 14px;
        font-weight: bold;
    }
    .modal_body_currilumn_header_hd {
        display: flex;
        padding: 1vh 0vh;
        font-size: 13px;
    }
    .modal_body_currilumn_header_hd span {
        font-weight: bold;
    }
    .modal_body_currilumn_header_bd {
        padding: 1vh 0vh;
        display: flex;
        font-size: 13px;
    }
    .tnv_ct {
        width: 60%;
    }
    .tnv_as {
        width: 20%;
        text-align: center;
    }
    .tnv_score {
        width: 20%;
        text-align: center;
    }
    .btn-download-tt {
        height: 40px;
        border: 2px solid #0071c5;
        background-color: #ffffff;
        color: black;
        font-size: 12px;
        font-weight: bold;
        border-radius: 5px;
        margin-top: 5px;
        margin-bottom: 0;
        transition: ease 0.5s;
        /* width: 140px; */
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/components/manage/detail/historyExamPc.vue